module.exports = __webpack_public_path__ + "img/certification.8eb784be.png";